import { render } from "./KillmailView.vue?vue&type=template&id=34f0d6c2"
import script from "./KillmailView.vue?vue&type=script&lang=js"
export * from "./KillmailView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\justi\\Code\\vuekillmailtool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__